export const setUserDetails=(user)=>{
    return {
        type: "SET_USER",
        user: user,
    }
}
export const nullUserDetails=()=>{
    return{
        type:"NULL_USER",
        user: null
    }
}
export const getUserDetails=()=>{
    return {
        type: "GET_USER",
        
    }
}

export const updateUserImageUrl = (image_url) => {
    return {
      type: "UPDATE_USER_IMAGE_URL",
      image_url,
    };
  };
  
